// ContactUs.jsx
import React, {useState} from 'react';
import './ContactUs.css';
import Footer from '../pages/Footer';
import FloatingOrderButton from '../components/FloatingOrderButton';
import { FaPhoneAlt, FaWhatsapp, FaEnvelope, FaMapMarkerAlt, FaClock, FaHeadset, FaQuestionCircle, FaComments } from 'react-icons/fa';
import promoImage from '../assets/about-highlight.jpeg';
import api from './api';

export default function ContactUs() {
  return (
    <div className="contact-page">
      <div className="contact-hero">
        <h1 className='contact-heading'>Contact Us</h1>
        <p className='contact-para'>Be a part of India's fastest growing dry-cleaning brand. Low investment, high return, full support.</p>
      </div>
      {/* <h1 className="contact-heading">Contact Us</h1>
      <div className="contact-cards">
        <div className="contact-card">
          <h2>Phone</h2>
          <p>+91 9138004800</p>
        </div>
        <div className="contact-card">
          <h2>WhatsApp</h2>
          <p>+91 9138004800</p>
        </div>
        <div className="contact-card">
          <h2>Email</h2>
          <p>happy2helpu@cleanz24.com</p>
        </div>
        <div className="contact-card">
          <h2>Office Address</h2>
          <p>1st Floor, Cleanz24 HQ, Delhi, India</p>
        </div>
      </div> */}
     <section className="contact-section">
        <div className="contact-intro">
          <h2>Let’s Connect</h2>
          <p>
            Have questions or want to explore opportunities with NeatnClean?
            Reach out through the form or connect via the contact options.
          </p>
        </div>

        <div className="contact-grid">
          <ContactForm></ContactForm>
          {/* <form className="contact-form">
            <input type="text" placeholder="Your Full Name" required />
            <input type="tel" placeholder="Contact Number" required />
            <input type="text" placeholder="City / Location" required />
            <div className="checkbox-wrap">
              <input type="checkbox" id="agree" required />
              <label htmlFor="agree">
                I agree to the <a href="/privacy-policy" target="_blank">Privacy Policy</a>
              </label>
            </div>
            <button type="submit">Send Message</button>
          </form> */}

          <div className="contact-info-cards">
            <div className="info-card">
              <FaPhoneAlt className="icon" />
              <h4>Call Us</h4>
              <p>+91 9654335152</p>
            </div>

            <div className="info-card">
              <FaWhatsapp className="icon" />
              <h4>WhatsApp</h4>
              <p>+91 9654335152</p>
            </div>

            <div className="info-card">
              <FaEnvelope className="icon" />
              <h4>Email</h4>
              <p>support@neatnclean.in</p>
            </div>

            <div className="info-card">
              <FaMapMarkerAlt className="icon" />
              <h4>Visit Us</h4>
              <p>H-16/431, Sangam Vihar, Hamdard Nagar, South Delhi, New Delhi, Delhi, India, 110062</p>
            </div>
          </div>
        </div>
      </section>
    {/* FAQ Section */}
    <section className="faq-section">
      <h2 className="section-title">Frequently Asked Questions</h2>
      <div className="faq-grid">
        <div className="faq-item">
          <h3>How do I schedule a pickup?</h3>
          <p>Simply call us or use our online booking system. We offer same-day pickup in most areas.</p>
        </div>
        <div className="faq-item">
          <h3>What are your service hours?</h3>
          <p>We operate 24/7 for pickup and delivery. Our cleaning facilities run from 6 AM to 10 PM.</p>
        </div>
        <div className="faq-item">
          <h3>Do you offer dry cleaning?</h3>
          <p>Yes, we provide professional dry cleaning services for delicate garments and formal wear.</p>
        </div>
        <div className="faq-item">
          <h3>What if I'm not satisfied?</h3>
          <p>We offer 100% satisfaction guarantee. If you're not happy, we'll re-clean or refund your money.</p>
        </div>
        <div className="faq-item">
          <h3>How do I track my order?</h3>
          <p>You'll receive SMS updates throughout the process, from pickup to delivery.</p>
        </div>
        <div className="faq-item">
          <h3>Do you clean household items?</h3>
          <p>Yes, we clean curtains, carpets, sofa covers, and other household textiles.</p>
        </div>
      </div>
    </section>

    {/* Support Hours Section */}
    <section className="support-hours">
      <h2 className="section-title">Support Hours</h2>
      <div className="hours-grid">
        <div className="hours-card">
          <div className="hours-icon"><FaClock /></div>
          <h3>Customer Support</h3>
          <p>24/7 Available</p>
          <span>Round-the-clock assistance</span>
        </div>
        <div className="hours-card">
          <div className="hours-icon"><FaHeadset /></div>
          <h3>Technical Support</h3>
          <p>6 AM - 10 PM</p>
          <span>Monday to Sunday</span>
        </div>
        <div className="hours-card">
          <div className="hours-icon"><FaComments /></div>
          <h3>Live Chat</h3>
          <p>8 AM - 8 PM</p>
          <span>Instant responses</span>
        </div>
      </div>
    </section>

    {/* Contact Methods Section */}
    <section className="contact-methods">
      <h2 className="section-title">Multiple Ways to Reach Us</h2>
      <div className="methods-grid">
        <div className="method-card">
          <div className="method-icon"><FaPhoneAlt /></div>
          <h3>Phone Support</h3>
          <p>Call us for immediate assistance with bookings, queries, or support.</p>
          <a href="tel:+919654335152" className="method-link">+91 9654335152</a>
        </div>
        <div className="method-card">
          <div className="method-icon"><FaWhatsapp /></div>
          <h3>WhatsApp</h3>
          <p>Quick messaging for non-urgent queries and updates.</p>
          <a href="https://wa.me/919654335152" className="method-link">Chat on WhatsApp</a>
        </div>
        <div className="method-card">
          <div className="method-icon"><FaEnvelope /></div>
          <h3>Email Support</h3>
          <p>Detailed queries and documentation via email.</p>
          <a href="mailto:support@neatnclean.in" className="method-link">support@neatnclean.in</a>
        </div>
        <div className="method-card">
          <div className="method-icon"><FaQuestionCircle /></div>
          <h3>Help Center</h3>
          <p>Self-service options and detailed guides.</p>
          <a href="/help" className="method-link">Visit Help Center</a>
        </div>
      </div>
    </section>

    <section className="support-message-section">
      <div className="support-message-content">
        <div className="support-text">
          <h2>We're Here 24/7 to Support You</h2>
          <p>
            At NeatnClean, your satisfaction is our top priority. Whether you're a franchise partner or a customer,
            our dedicated team is available around the clock to assist you. From onboarding to daily operations,
            we're committed to providing seamless support, fast solutions, and human-friendly communication—anytime you need us.
          </p>
        </div>
        <div className="highlight-left">
              <img src={promoImage} alt="Laundry Highlight" className="highlight-image" />
            </div>
      </div>
    </section>
    <Footer />
    <FloatingOrderButton />
    </div>
  );
}

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    city: '',
    agreed: false
  });
  const [submitting, setSubmitting] = useState(false);
  const [popupMessage, setPopupMessage] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, phone, city, agreed } = formData;
    if (!name || !phone || !city || !agreed) {
      showPopup("Please fill all fields and agree to the policy.");
      return;
    }

    setSubmitting(true);

    try {
      await api.post('/contactRecord', {
        name,
        phoneNumber: phone,
        city
      });
      showPopup("Message sent successfully!");
      setFormData({ name: '', phone: '', city: '', agreed: false });
    } catch (err) {
      showPopup("Failed to send message. Try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const showPopup = (msg) => {
    setPopupMessage(msg);
    setTimeout(() => setPopupMessage(null), 3000);
  };

  return (
    <>
      <form className="contact-form" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Your Full Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          placeholder="Contact Number"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          placeholder="City / Location"
          name="city"
          value={formData.city}
          onChange={handleChange}
          required
        />

        <div className="checkbox-wrap">
          <input
            type="checkbox"
            id="agree"
            name="agreed"
            checked={formData.agreed}
            onChange={handleChange}
            required
          />
          <label htmlFor="agree">
            I agree to the <a href="/privacy-policy" target="_blank">Privacy Policy</a>
          </label>
        </div>

        <button type="submit" disabled={submitting}>
          {submitting ? "Sending..." : "Send Message"}
        </button>
      </form>

      {popupMessage && <div className="popup-message">{popupMessage}</div>}
    </>
  );
};
